import React, { useEffect } from 'react';
import AppRoutes from './appRoutes';
import ScrollToTop from './components/ScrollToTop';
import CookieConsent from './components/CookieConsent';
import { APP_NAME } from './config/branding';

function App() {
  useEffect(() => {
    document.title = APP_NAME;
  }, []);

  return (
    <>
      <ScrollToTop />
      <AppRoutes />
      <CookieConsent />
    </>
  );
}

export default App;
